<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" label-width="150px" v-loading="loading">
        <el-form-item prop="loginId" label="客户类型：">
          <span v-if="formData.userType === '2'">储运客户</span>
          <span v-if="formData.userType === '3'">云销客户</span>
          <span v-if="formData.userType === '2,3'">储运客户,云销客户</span>
        </el-form-item>
        <el-form-item prop="loginId" label="登录账号：">
          {{ formData.loginId || "-" }}
        </el-form-item>
        <el-form-item prop="mobile" label="手机号：">
          {{ formData.mobile || "-" }}
        </el-form-item>
        <!-- 客户/供应商详情展示两类独立编码，避免把客户编码当作账套编码。 -->
        <el-form-item prop="userNo" label="客户/供应商编码：">
          {{ formData.userNo || "-" }}
        </el-form-item>
        <el-form-item prop="accountSetCode" label="账套编码：">
          {{ formData.accountSetCode || "-" }}
        </el-form-item>
        <el-form-item prop="roleName" label="角色：">
          {{ formData.roleName || "-" }}
        </el-form-item>
        <el-form-item prop="serviceUserName" label="关联用户：">
          {{ formData.serviceUserName || "-" }}
        </el-form-item>
        <el-form-item prop="fileList" label="附件：">
          <file-upload readonly v-model="formData.fileList"></file-upload>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>

export default {
  name: 'ygUserDetail',
  data() {
    return {
      formData: {},
      dicList: [],
      loading: false
    }
  },
  created() {
    if (this.userId) {
      this.loadData()
    }
  },
  computed: {
    userId() {
      return this.$route.query.userId
    }
  },
  methods: {

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.system.selectSysUserByUserId, {
        params: { userId: this.userId }
      }).then(res => {
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 450px;
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
